module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-02.a96f342c.png";